import $http from '@/core/services/http.service';
import { ActionTree } from 'vuex';
import { State } from '@/manager/billing/store/state';
import Endpoints from '@/constants/endpoints';

import UtilsService from '@/core/services/utils.service';
import Bill from '@/manager/billing/models/bill.model';

export interface Actions {
    fetchBillList: {  };
}

export const actions: ActionTree<State, any> = {

    fetchBill: ({ commit }, payload) => {
        return new Promise(( resolve, reject ) => {
            $http.get(`${Endpoints.bill}${payload.id}/`)
                .then((res) => {
                        const data = res.data;
                        commit('updateBill', data);
                        resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    // fetchRefundedOriginBill: ({ commit }, payload) => {
    //     return new Promise(( resolve, reject ) => {
    //         $http.get(`${Endpoints.bill}${payload.id}/`)
    //             .then((res) => {
    //                     const data = res.data;
    //                     // commit('updateBill', data);
    //                     resolve(data);
    //             })
    //             .catch((err) => {
    //                 reject(err);
    //             });
    //     });
    // },
    fetchRefundedOriginBill: ({ commit }, payload) => {
        return new Promise(( resolve, reject ) => {
            $http.get(`${Endpoints.bill}${payload.id}/refunded-origin`)
                .then((res) => {
                        const data = res.data;
                        // commit('updateBill', data);
                        resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    fetchPurchaseFromBill: ({ commit }, payload) => {
        return new Promise(( resolve, reject ) => {
            $http.get(`${Endpoints.bill}${payload.id}/puchase-from-bill`)
                .then((res) => {
                        const data = res.data;
                        // commit('purchaseFromBill', data);
                        resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    fetchBillList: ({ commit }, payload) => {
        return new Promise(( resolve, reject ) => {
            let params: any = {};
            params = UtilsService.getQueryParams(payload);
            $http.get(`${Endpoints.bill}`, { params })
                .then((res) => {
                        const data = res.data;
                        commit('setBillList', data.results);
                        resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    fetchBillNotes: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            $http.get(`${Endpoints.bill}${payload.id}/note/`)
                .then((res) => {
                    const data = res.data.results;
                    commit( 'setBillNotes', { billId: payload.id, notes: data} );
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    newBillNote: ({commit}, payload) => {
        return new Promise((resolve, reject) => {
            $http.post(
                `${Endpoints.bill}${payload.billId}/note/`,
                {
                    employee: payload.employee,
                    note: payload.note,
                    type: payload.type,
                    mentions: payload.mentions
                },
            )
                .then((res) => {
                    const data = res.data;
                    commit( 'newBillNote', data );
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    patchBillNote: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            $http.patch(`${Endpoints.bill}${payload.billId}/note/${payload.noteId}/`, payload.data)
                .then((res) => {
                    commit('updateParticipantNote', res.data);
                    resolve(res.data);
                }).catch((err) => {
                    reject(err);
                });
        });
    },
    removeBillNote: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            $http.delete(`${Endpoints.bill}${payload.id}/note/${payload.noteId}/`)
                .then(() => {
                    commit('removeBillNote', payload.noteId);
                    resolve(payload.noteId);
                }).catch((err) => {
                    reject(err);
                });
        });
    },
    setCurrentBill: ({ commit }, payload) => {
        commit('setCurrentBill', payload);
    },
    newBill: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            $http.post(`${Endpoints.bill}`, payload)
                .then((res) => {
                    const data = res.data;
                    commit( 'newBill', data );
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    updateBill: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            $http.put(`${Endpoints.bill}${payload.id}/`, payload)
                .then((res) => {
                    const data = res.data;
                    commit( 'updateBill', data );
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};
